/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useContext, useState, useEffect, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
    createResponseContext,
    initialQueryResponse,
    WithChildren,
} from '../../../../../general/helpers'
import { get_promotion_query } from '../../core/_request'
import { prepareQueryString } from '../../core/helper'
import { PromotionsResponse } from '../../core/_models'
import { usePromotionsQueryRequest } from './PromotionsRequestProvider'

const QueryResponseContext = createResponseContext<PromotionsResponse>(initialQueryResponse)
const PromotionsQueryResponseProvider: FC<WithChildren> = ({ children }) => {
    const { state, loading, toggleLoading } = usePromotionsQueryRequest()

    // Use prepareQueryString instead of extractQueryParams to match legacy style and include '?'
    const [query, setQuery] = useState<string>(prepareQueryString({ ...state, page: (state.page || 1) - 1 }))
    const updatedQuery = useMemo(() => prepareQueryString({ ...state, page: (state.page || 1) - 1 }), [state])

    useEffect(() => {
        if (query !== updatedQuery) {
            setQuery(updatedQuery)
        }
    }, [updatedQuery])

    const {
        isFetching,
        refetch,
        data: response,
    } = useQuery(
        `promotions-list-${query}`,
        () => {
            return get_promotion_query(localStorage.getItem('kt-auth-react-v') ? JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')?.accessToken : '', query)
        },
        {
            cacheTime: 0,
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            onSettled: () => {
                loading && toggleLoading?.()
            },
            retry: false,
        }
    )

    return (
        <QueryResponseContext.Provider value={{ isLoading: isFetching, refetch, response, query }}>
            {children}
        </QueryResponseContext.Provider>
    )
}

const usePromotionsQueryResponse = () => useContext(QueryResponseContext)

const usePromotionsQueryResponseData = () => {
    const { response } = usePromotionsQueryResponse()
    if (!response) {
        return []
    }

    return response.promotions || []
}

const usePromotionsQueryResponseLoading = (): boolean => {
    const { isLoading } = usePromotionsQueryResponse()
    return isLoading
}

const usePromotionsQueryResponseTotalCount = (): number => {
    const { response } = usePromotionsQueryResponse()
    return response?.totalCounts ?? 0
}

export {
    PromotionsQueryResponseProvider,
    usePromotionsQueryResponse,
    usePromotionsQueryResponseData,
    usePromotionsQueryResponseLoading,
    usePromotionsQueryResponseTotalCount,
}
